import axios from "axios"
import { useEffect, useState } from "react"
import { REZEPT_SEARCH_ENDPOINT } from "../../const/Endpoints"
import { STRAPI_API_KEY } from "../../const/Keys"
import { alenaxios } from "../../functions/alenaxios"

export function useRecipeSearch(searchStr = "") {
    const [Data, setData] = useState(null)
    const [Error, setError] = useState(null)
    const [Loading, setLoading] = useState(false)


    useEffect(() => {
        (
            async function () {
                let endpoint = REZEPT_SEARCH_ENDPOINT + searchStr
                setError(false)
                setLoading(true)

                let config = {
                    method: 'get',
                    url: endpoint,
                    headers: {
                        'Authorization': `Bearer ${STRAPI_API_KEY}`
                    }
                };

                let fetcher = searchStr == "" ? alenaxios : axios

                fetcher(config)
                    .then(res => { setData(res?.data || []) })
                    .catch(() => setError(true))
                    .finally(() => setLoading(false))
            }
        )()
    }, [searchStr])

    return { Data, Loading, Error }
}